export default __webpack_public_path__ + "static/media/cyber-two-people.d36d389d.jpg";